<div class="modal-header" medptevlog>
  <h2 class="modal-title" id="modal-title">Delegated Training</h2>
  <span type="button" class="btn-close" (click)="modal.dismiss('')" medpt-log-action="CloseModel" [attr.medpt-log-message]="'Close Delegated Training Model'"></span>
</div>
<div class="modal-body" medptevlog>
  <div class="row">
    <div class="col col-md-12">
      <p><strong>{{delegateInputModel.AssetName}}</strong></p>
    </div>
    <div class="col col-md-12">
      <kendo-grid [data]="DelegatedUsers">
        <kendo-grid-column field="DelegatorUserName" title="Delegator" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>
              {{dataItem.DelegatorUserName}}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="DelegatedUserName" title="Delegate" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>
              {{dataItem.DelegatedUserName}}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="UpdateByUserName" title="Updated By" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            <span>
              {{dataItem.UpdateByUserName}}
            </span>
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="DateCreated" title="Date" [width]="100">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{dataItem.DateCreated == '0001-01-01T00:00:00' ? "" : dataItem.DateCreated | date: 'dd MMM yyyy'}}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  </div>
</div>
<div class="modal-footer" medptevlog>
  <button type="button" class="secondaryBtn" (click)="modal.dismiss('')" medpt-log-action="CloseModel" [attr.medpt-log-message]="'Close Delegated Training Model'">Close</button>
</div>

